import { routeConfig } from '@/components/modules/rule-components/routeConfig'
import type { FormContextType } from '@/routes/rule/visit-website.lazy'
import { createFileRoute } from '@tanstack/react-router'
import { createContext } from 'react'

export const Route = createFileRoute('/rule/visit-website')(routeConfig())
export const FormContext = createContext<FormContextType>({} as FormContextType) // <--- 留意这个类型
